import { render, staticRenderFns } from "./grading-definition.vue?vue&type=template&id=63cbc33d&scoped=true&"
import script from "./grading-definition.vue?vue&type=script&lang=js&"
export * from "./grading-definition.vue?vue&type=script&lang=js&"
import style0 from "./grading-definition.vue?vue&type=style&index=0&id=63cbc33d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cbc33d",
  null
  
)

export default component.exports